export default "__VITE_ASSET__7b370586__"